import { Dropdown, MenuItem } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";

const CollaboratorActionButton = ({ availableActions, deleteCollaborator }) => {
  return (
    <Dropdown
      pullRight
      id="collaborator-actions-dropdown"
      className="dropdown-action-btn pull-right">
      <Dropdown.Toggle className="btn-wd btn-icon">
        <i className="fa fa-lg fa-check" />
        Action
      </Dropdown.Toggle>
      <Dropdown.Menu className="action-dropdown-menu">
        {availableActions.includes("DELETECOLLABORATOR") ? (
          <MenuItem
            onClick={() => {
              console.log("call deleteCollaborator()");
              deleteCollaborator();
            }}
            eventKey="1">
            <i className="fa fa-lg fa-trash" />

            <FormattedMessage id="ids_deleteCollaborator" />
          </MenuItem>
        ) : (
          <div />
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CollaboratorActionButton;
